import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectService } from '@catcore/services';
import { Project } from '@catcore/types/api-v2';
import { UserdataGenerationService } from '@catmodules/models/userdata-generation/services/userdata-generation.service';
import { ExplorerItem, TreeNodeInfo } from '@catui/types';
import { isNullOrUndefined } from 'util';

const buildDefaultExplorerItem = (project: Project, displayName: string, targetRef: string): ExplorerItem => {
  return {label: displayName, value: {route: ['projects', `${project.id}`, 'packages-generation', targetRef]}, expanded: false, allowedActions: []};
};

@Component({
  selector: 'catapp-userdata-generation',
  templateUrl: './userdata-generation.component.html',
  styleUrls: ['./userdata-generation.component.scss'],
})
export class UserdataGenerationComponent implements OnInit, OnDestroy {
  doAllowCreate = false;
  activeItem = false;
  explorerItems: ExplorerItem[] = [];
  subscription = null;

  constructor(private projectService: ProjectService,
              private router: Router,
              private userdataGenerationService: UserdataGenerationService) {
  }

  navigateTo(node: TreeNodeInfo) {
    this.router.navigate(node.item.value.route);

  }

  ngOnInit() {
    this.subscription = this.projectService
      .getCurrentProject()
      .subscribe((project: Project) => {
        if (!isNullOrUndefined(project)) {
          this.explorerItems = [];
          this.explorerItems.push(buildDefaultExplorerItem(project, 'Userdata', 'user-data'));
        }
      });
    this.userdataGenerationService.setActive();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.userdataGenerationService.setInactive();
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/components/userdata-generation/userdata-generation.component.ts